<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Review'"
      [canGoBack]="true"
      [customBackAction]="topNavBack" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="windowService.isDesktopRes ? 'right-side-scroll-enabled' : ''">
    @if (review) {
      <tidy-card class="reviews-detail__hero">
        <span class="platform-chip" [ngClass]="platformChipClass">{{ channelLabel }}</span>
        <div class="reviews-detail__hero-body">
          <div class="reviews-detail__hero-avatar">
            <tidy-initials-icon [fullName]="review.guest_name || 'Guest'" />
          </div>
          <tidy-text
            [title]="review.guest_name || 'Guest'"
            [translate]="false" />
          @if (review.listing_name) {
            <tidy-text
              [helper]="('Stayed at ' | translate) + review.listing_name"
              [translate]="false" />
          }
          <div class="reviews-detail__hero-rating">
            <star-rating [value]="overallStars" [readonly]="true" [size]="'small'" />
            <span class="reviews-detail__rating-caption">{{ ratingCaption }}</span>
          </div>
          @if (review.stay_dates) {
            <div class="reviews-detail__hero-meta">
              <tidy-image [src]="'assets/svg/calendar-outline.svg'" class="reviews-detail__meta-icon" />
              <tidy-text
                [helper]="review.stay_dates"
                [translate]="false" />
            </div>
          }
        </div>
      </tidy-card>

      @if (review.comment) {
        <tidy-card class="reviews-detail__quote">
          <div class="reviews-detail__quote-mark">&ldquo;</div>
          <tidy-text
            [body]="review.comment"
            [translate]="false"
            class="reviews-detail__quote-text" />
        </tidy-card>
      }

      @if (subRatings.length > 0) {
        <tidy-card>
          <tidy-row>
            <tidy-text [title]="'Ratings'" />
          </tidy-row>
          @for (sub of subRatings; track sub.label) {
            <div class="reviews-detail__rating-row">
              <tidy-text
                [body]="sub.label"
                [translate]="false" />
              <star-rating [value]="sub.value" [readonly]="true" [size]="'small'" />
            </div>
          }
        </tidy-card>
      }

      @if (hasResponded) {
        <tidy-card>
          <tidy-row>
            <tidy-text [title]="'Your Response'" />
          </tidy-row>
          <div class="reviews-detail__response-bubble">
            <div class="reviews-detail__response-meta">
              <tidy-image [src]="'assets/svg/checkmark-circle.svg'" class="reviews-detail__response-check" />
              <tidy-text
                [helper]="respondedLabel"
                [translate]="false" />
            </div>
            @if (hostResponse) {
              <tidy-text
                [body]="hostResponse"
                [translate]="false" />
            } @else {
              <tidy-text [helper]="'You have responded to this review.'" />
            }
          </div>
        </tidy-card>
      } @else if (!respondAvailable) {
        <tidy-card>
          <tidy-row>
            <tidy-text [title]="'Respond to this Review'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [helper]="respondUnavailableMessage"
              [translate]="false" />
          </tidy-row>
        </tidy-card>
      } @else {
        <tidy-card>
          <tidy-row>
            <tidy-text [title]="'Respond to this Review'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [helper]="('Your reply is posted publicly on ' | translate) + channelLabel + '.'"
              [translate]="false" />
          </tidy-row>
          @if (responseError) {
            <tidy-error-message [text]="responseError" />
          }
          <form [formGroup]="form" novalidate action="#">
            <tidy-textarea
              [label]="'Your response'"
              formControlName="response"
              [form]="form.controls.response"
              [icon]="'assets/svg/create-outline.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please write a response'" />
          </form>
          <tidy-button
            [text]="submitting ? 'Posting…' : (responseError ? 'Retry Response' : 'Post Response')"
            [action]="submitResponse"
            class="primary"
            [disabled]="submitting" />
        </tidy-card>
      }
    }
  </tidy-wrapper>
</ng-template>

@if (windowService.isDesktopRes) {
  <ng-container *ngTemplateOutlet="content" />
} @else {
  <app-scroll-wrapper [templateContent]="content" />
}
